import { render, staticRenderFns } from "./EditDescriptionDialog.vue?vue&type=template&id=d0b7a3ba&scoped=true&"
import script from "./EditDescriptionDialog.vue?vue&type=script&lang=js&"
export * from "./EditDescriptionDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditDescriptionDialog.vue?vue&type=style&index=0&id=d0b7a3ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b7a3ba",
  null
  
)

export default component.exports